import { AxiosResponse } from 'axios';
import {
	PreviewReportResponse,
	ReportStatusResponse,
	RunReportResponse,
} from '../types/reports';
import { getApiUrl } from '../util/util';
import { get, post } from './http';

interface ReportsApi {
	getReportStatus(
		authorizationToken: string,
		reportLocator: string,
	): Promise<AxiosResponse<ReportStatusResponse>>;
	runAllPoliciesReport(
		authorizationToken: string,
		req: any,
	): Promise<AxiosResponse<RunReportResponse>>;
	runAllPoliciesReportPreview(
		authorizationToken: string,
		req: any,
	): Promise<AxiosResponse<PreviewReportResponse>>;
	runOnRiskReport(
		authorizationToken: string,
		req: any,
	): Promise<AxiosResponse<RunReportResponse>>;
	runOnRiskReportPreview(
		authorizationToken: string,
		req: any,
	): Promise<AxiosResponse<PreviewReportResponse>>;
	runFinancialTransactionsReport(
		authorizationToken: string,
		req: any,
	): Promise<AxiosResponse<RunReportResponse>>;
	runFinancialTransactionsReportPreview(
		authorizationToken: string,
		req: any,
	): Promise<AxiosResponse<PreviewReportResponse>>;
	runPaidFinancialTransactionsReport(
		authorizationToken: string,
		req: any,
	): Promise<AxiosResponse<RunReportResponse>>;
	runPaidFinancialTransactionsReportPreview(
		authorizationToken: string,
		req: any,
	): Promise<AxiosResponse<PreviewReportResponse>>;
	runUnearnedPremiumReport(
		authorizationToken: string,
		req: any,
	): Promise<AxiosResponse<RunReportResponse>>;
	runUnearnedPremiumReportPreview(
		authorizationToken: string,
		req: any,
	): Promise<AxiosResponse<PreviewReportResponse>>;
	runPayableCommissionsReport(
		authorizationToken: string,
		req: any,
	): Promise<AxiosResponse<RunReportResponse>>;
	runPayableCommissionsReportPreview(
		authorizationToken: string,
		req: any,
	): Promise<AxiosResponse<PreviewReportResponse>>;
	runClaimsReservesReport(
		authorizationToken: string,
		req: any,
	): Promise<AxiosResponse<RunReportResponse>>;
	runClaimsReservesReportPreview(
		authorizationToken: string,
		req: any,
	): Promise<AxiosResponse<PreviewReportResponse>>;
	runClaimsReport(
		authorizationToken: string,
		req: any,
	): Promise<AxiosResponse<RunReportResponse>>;
	runClaimsReportPreview(
		authorizationToken: string,
		req: any,
	): Promise<AxiosResponse<PreviewReportResponse>>;
	runClaimsPayableReport(
		authorizationToken: string,
		req: any,
	): Promise<AxiosResponse<RunReportResponse>>;
	runClaimsPayableReportPreview(
		authorizationToken: string,
		req: any,
	): Promise<AxiosResponse<PreviewReportResponse>>;
}

export default {
	getReportStatus(authorizationToken: string, reportLocator: string) {
		return get(
			`${getApiUrl()}/report/${reportLocator}/status`,
			authorizationToken,
		);
	},

	runAllPoliciesReport(authorizationToken: string, req: any) {
		return post(`${getApiUrl()}/report/allPolicies`, authorizationToken, req);
	},

	runAllPoliciesReportPreview(authorizationToken: string, req: any) {
		return post(
			`${getApiUrl()}/report/allPoliciesPreview`,
			authorizationToken,
			req,
		);
	},

	runOnRiskReport(authorizationToken: string, req: any) {
		return post(`${getApiUrl()}/report/onRisk`, authorizationToken, req);
	},

	runOnRiskReportPreview(authorizationToken: string, req: any) {
		return post(`${getApiUrl()}/report/onRiskPreview`, authorizationToken, req);
	},

	runFinancialTransactionsReport(authorizationToken: string, req: any) {
		return post(
			`${getApiUrl()}/report/financialTransaction`,
			authorizationToken,
			req,
		);
	},

	runFinancialTransactionsReportPreview(authorizationToken: string, req: any) {
		return post(
			`${getApiUrl()}/report/financialTransactionPreview`,
			authorizationToken,
			req,
		);
	},

	runPaidFinancialTransactionsReport(authorizationToken: string, req: any) {
		return post(
			`${getApiUrl()}/report/paidFinancialTransaction`,
			authorizationToken,
			req,
		);
	},

	runPaidFinancialTransactionsReportPreview(
		authorizationToken: string,
		req: any,
	) {
		return post(
			`${getApiUrl()}/report/paidFinancialTransactionPreview`,
			authorizationToken,
			req,
		);
	},

	runUnearnedPremiumReport(authorizationToken: string, req: any) {
		return post(
			`${getApiUrl()}/report/unearnedPremium/accountsReceivable`,
			authorizationToken,
			req,
		);
	},

	runUnearnedPremiumReportPreview(authorizationToken: string, req: any) {
		return post(
			`${getApiUrl()}/report/unearnedPremium/accountsReceivable/preview`,
			authorizationToken,
			req,
		);
	},

	runPayableCommissionsReport(authorizationToken: string, req: any) {
		return post(
			`${getApiUrl()}/report/payableCommissions`,
			authorizationToken,
			req,
		);
	},

	runPayableCommissionsReportPreview(authorizationToken: string, req: any) {
		return post(
			`${getApiUrl()}/report/payableCommissions/preview`,
			authorizationToken,
			req,
		);
	},

	runClaimsReservesReport(authorizationToken: string, req: any) {
		return post(
			`${getApiUrl()}/report/claim/reserves`,
			authorizationToken,
			req,
		);
	},

	runClaimsReservesReportPreview(authorizationToken: string, req: any) {
		return post(
			`${getApiUrl()}/report/claim/reserves/preview`,
			authorizationToken,
			req,
		);
	},

	runClaimsReport(authorizationToken: string, req: any) {
		return post(`${getApiUrl()}/report/claim`, authorizationToken, req);
	},

	runClaimsReportPreview(authorizationToken: string, req: any) {
		return post(`${getApiUrl()}/report/claim/preview`, authorizationToken, req);
	},

	runClaimsPayableReport(authorizationToken: string, req: any) {
		return post(
			`${getApiUrl()}/report/claim/payables`,
			authorizationToken,
			req,
		);
	},

	runClaimsPayableReportPreview(authorizationToken: string, req: any) {
		return post(
			`${getApiUrl()}/report/claim/payables/preview`,
			authorizationToken,
			req,
		);
	},
} as ReportsApi;
